import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { CustomToast } from '../../widgets/components/UI/CustomToast'

export const EditCaptableModal = ({
  modalOpen,
  setModalOpen,
  updateCaptable,
  isLoading,
  title,
  inputText,
  setInputText,
}: any) => {
  const { formatMessage } = useIntl()

  return (
    <>
      <Modal show={modalOpen} onHide={() => setModalOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomToast
            className='mb-lg-15 mb-8'
            status={`${title === 'Authorized Capital'
              ? "Enter your company's maximum legal share capital limit - this helps us validate your fundraising capacity and ensure compliance with your incorporation documents."
              : 'Enter the total number of shares your company is authorized to issue - this defines your maximum share distribution limit as specified in your incorporation documents.'
              }`}
            isPrimary={true}
          />
          <div className='fv-row mb-8'>
            <input
              type='number'
              className='form-control'
              value={inputText}
              onChange={(e) => setInputText(parseInt(e.target.value))}
              placeholder='Enter'
            />
          </div>
        </Modal.Body>
        <Modal.Footer className='d-flex flex-md-row flex-column'>
          <button className='btn bg-light text-muted custom-button-property w-100 w-md-auto order-2 order-md-1' onClick={() => setModalOpen(false)}>
            {formatMessage({ id: 'Cancel' })}
          </button>
          <button className='btn bg-primary text-white custom-button-property w-100 w-md-auto order-1 order-md-2' onClick={() => updateCaptable()} disabled={isLoading}>
            {isLoading ? formatMessage({ id: 'Please wait...' }) : formatMessage({ id: 'Submit' })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
